/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { TimeClockEmployeeViewService } from '../../view/time-clock-employee.view-service';
import { TimeClockEmployeeComponentModel } from './time-clock-employee.component-model';

@Component({
  selector: 'app-time-clock-employee',
  templateUrl: './time-clock-employee.component.html',
  styleUrls: ['./time-clock-employee.component.scss'],
  providers: [TimeClockEmployeeViewService],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeClockEmployeeComponent implements OnInit, OnDestroy {

  constructor(private readonly viewService: TimeClockEmployeeViewService) { }

  ngOnInit() {
    this.viewService.initialize();
  }

  ngOnDestroy(): void {
    this.viewService.finalize();
  }

  get model(): TimeClockEmployeeComponentModel {
    return this.viewService.componentModel;
  }

}
